export default __webpack_public_path__ + "static/media/total-admins.f614c3cd.svg";